import styled from 'styled-components';

import { Modal } from '@telialt/common-modal/src';
import { ModalBodyContent, ModalContent } from '@telialt/common-modal/src/Modal.styles';
import { getPurpurColor, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const ImageModalWrapper = styled(Modal)`
    && img {
        max-width: 100%;
    }

    ${ModalContent} {
        ${purpurMedia('md')`
            width: fit-content;
        `};
    }
    ${ModalBodyContent} {
        text-align: center;
    }
`;

export const CloseButton = styled.button`
    cursor: pointer;
    float: right;

    background: transparent;
    border: 0;
    padding: 0;

    width: 3rem;
    height: 3rem;
    color: black;
    opacity: 1;
    text-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;

    &:hover svg,
    &:focus svg {
        color: ${getPurpurColor('purple500')};
        opacity: 1;
    }
`;
